<template>
  <svg
    width="11"
    height="18"
    viewBox="0 0 11 18"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.681738 8.33711L8.27352 0.745703C8.63953 0.379688 9.23328 0.379688 9.5993 0.745703L10.4848 1.63125C10.8505 1.99687 10.8509 2.58906 10.4864 2.95547L4.46962 9L10.486 15.0449C10.8509 15.4113 10.8501 16.0035 10.4845 16.3691L9.59891 17.2547C9.23289 17.6207 8.63914 17.6207 8.27313 17.2547L0.681738 9.66289C0.315723 9.29687 0.315723 8.70312 0.681738 8.33711Z"
      fill="currentColor"
    />
  </svg>
</template>
